import React from 'react';
import { Progress, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token }) => ({
    previewContainer: {
        padding: '12px 16px',
        backgroundColor: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
    },
    previewContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    imagePreview: {
        width: '60px',
        height: '60px',
        objectFit: 'cover',
        borderRadius: '6px',
        border: `1px solid ${token.colorBorderSecondary}`,
    },
    previewInfo: {
        flex: 1,
        minWidth: 0,
    },
    fileName: {
        fontSize: '14px',
        fontWeight: 500,
        color: token.colorText,
        marginBottom: '4px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    progressContainer: {
        marginBottom: '8px',
    },
    closeButton: {
        color: token.colorTextSecondary,
        border: 'none',
        padding: '4px',
        height: 'auto',
        minHeight: 'auto',
    },
}));

interface ImagePreviewProps {
    imagePreview: string | null;
    uploadProgress: number;
    selectedImage: File | null;
    onClose?: () => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
    imagePreview,
    uploadProgress,
    selectedImage,
    onClose,
}) => {
    const { styles } = useStyles();

    if (!imagePreview || !selectedImage) {
        return null;
    }

    return (
        <div className={styles.previewContainer}>
            <div className={styles.previewContent}>
                {/* <img
                    src={imagePreview}
                    alt="预览"
                    className={styles.imagePreview}
                /> */}
                <div className={styles.previewInfo}>
                    <div className={styles.fileName}>
                        {selectedImage.name}
                    </div>
                    <div className={styles.progressContainer}>
                        <Progress
                            percent={uploadProgress}
                            size="small"
                            status={uploadProgress === 100 ? 'success' : 'active'}
                            showInfo={false}
                        />
                    </div>
                </div>
                {onClose && (
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={onClose}
                        className={styles.closeButton}
                    />
                )}
            </div>
        </div>
    );
}; 